import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export interface LoadingStateProps {
  message?: string;
}

/**
 * LoadingState — skeleton placeholder for perceived performance.
 *
 * Replaces a static spinner with content-shaped skeletons so the user
 * sees the approximate layout before data arrives.
 */
export function LoadingState({ message }: LoadingStateProps) {
  return (
    <Box
      className="page-state loading-state"
      role="status"
      aria-live="polite"
      sx={{ p: 3 }}
    >
      {/* Title skeleton */}
      <Skeleton variant="rounded" width="45%" height={36} sx={{ mb: 1 }} />
      {/* Subtitle skeleton */}
      <Skeleton variant="rounded" width="30%" height={20} sx={{ mb: 3 }} />

      {/* Content skeletons */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Skeleton variant="rounded" width="100%" height={80} />
        <Skeleton variant="rounded" width="100%" height={80} />
        <Skeleton variant="rounded" width="100%" height={80} />
      </Box>

      {message && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3, textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}
